


// Vue
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { Mixins } from 'vue-mixin-decorator';

// // Models
import { TypeOfProduct } from '@/manager/product/models/product.model';
import BillLine from '@/manager/billing/models/bill-line.model';

// Components
import Field from '@/shared/components/field.component.vue';
import Input, { InputSize, InputType, InputStyle } from '@/shared/components/input.component.vue';
import Icon, { IconEnum } from '@/shared/components/icon.component.vue';
import NumberPicker, {
    NumberPickerColor,
    NumberPickerSize,
} from '@/shared/components/number-picker.component.vue';

// Filters
import round from '@/shared/filters/round.filter.ts';


@Component({
    components: {
        Field,
        Icon,
        Input,
        NumberPicker,
    },
    computed: {
        ...mapGetters({
            getProfile: 'getProfile',
            getProduct: 'getProduct',
            productList: 'getProductList',
            currentBill: 'getCurrentBill',
        }),
    },
    filters: {
        round,
    },
})
export default class ShoppingCartLineBillReceived extends Vue {
    @Prop() private billLine!: any;


    private inputStyle = InputStyle;
    private iconEnum = IconEnum;
    private numberPickerColor = NumberPickerColor;
    private numberPickerSize = NumberPickerSize;
    private productSelected: any = { label: '', value: '' };
    private productList!: any;
    private getProduct!: any;
    private currentBill!: any;
    private inputSize = InputSize;
    private inputType = InputType;


    get billLineHasPrice() {
        return this.billLine.productPrice;
    }

    get billLineTotalPrice() {
        let price = 0;
        if ( this.billLineHasPrice ) {
            price = this.billLine.productAmount * Number(this.billLine.productPrice);
            const tax = (Number(this.billLine.productTax) + 100) / 100;
            this.billLine.totalPriceWithoutTax = price;
            price = price * tax;
            this.billLine.totalPrice = price;
        }
        return price;
    }

    get lineComplete() {
        return (
            this.billLine.product &&
            this.billLine.product.id &&
            (this.billLine as any).productAmount > 0
        );
    }

    get getProductTax() {
        let tax = this.billLine.productTax;
        if ( tax !== undefined ) {
            tax = tax.toString();
        }
        return tax;
    }

    get getProductPrice() {
        let price = this.billLine.productPrice;
        if ( price !== undefined ) {
            price = price.toString();
        }
        return price;
    }

    get lastLineEmpty() {
        const lines = this.currentBill.billLine;
        const linesLength = lines.length;
        const productName = lines[linesLength - 1].productName;
        return productName.length === 0;
    }


    private removeLine() {
        this.$emit('remove-line', this.billLine);
    }

    private addNewBillLine() {
        if ( !this.lastLineEmpty ) {
            this.$emit('new-line');
        }
    }

    private checkAddLine() {
        if ( this.billLine.productName !== undefined && this.billLine.productName.length > 0  ) {
            this.billLine.productAmount = 1;
            this.addNewBillLine();
        }
    }

}
